import styled from 'styled-components';
import { ModalBody } from 'reactstrap';

const StyledModalBody = styled(ModalBody)`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #6e7582;
`;
export { StyledModalBody };
